import { Injectable } from '@angular/core'
import { UnespCoreUserService } from '@unesp/core'
import { BehaviorSubject } from 'rxjs'
import { UsuarioLogin } from 'src/app/models/usuario-login'

@Injectable({
  providedIn: 'root',
})
export class UserLoginService {
  constructor(private unespCoreUserService: UnespCoreUserService) {
    this.unespCoreUserService.user$.subscribe(user => {
      this._userLogin$.next(user as UsuarioLogin)
    })
  }

  private _userLogin$ = new BehaviorSubject<UsuarioLogin | null>(null)

  get user$(): BehaviorSubject<UsuarioLogin | null> {
    return this._userLogin$
  }

  getUser(): UsuarioLogin | null {
    return this.unespCoreUserService.getUser() as UsuarioLogin
  }
}
